export default __webpack_public_path__ + "static/media/TermProtection.cf1c41da.svg";